import * as React from "react";

import Logout from "../components/Logout";

const logoutPage: React.FC = () => {
	return <Logout />;
};

export default logoutPage;
